import { render, staticRenderFns } from "./PointTag.vue?vue&type=template&id=8715bec2&scoped=true"
import script from "./PointTag.vue?vue&type=script&lang=js"
export * from "./PointTag.vue?vue&type=script&lang=js"
import style0 from "./PointTag.vue?vue&type=style&index=0&id=8715bec2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8715bec2",
  null
  
)

export default component.exports